module.exports = __webpack_public_path__ + "img/card_bkg.c3382378.png";